import {
  AdditionalParameters,
  FilterInterval,
  FilterIntervalType,
  FilterOperators,
  FilterText,
  Parameters,
} from 'commerce/factFinder/queryParameters/types';
import { Facets } from 'commerce/factFinder/types';

const operators: Record<FilterOperators, string> = { and: '___', or: '~~~' };

const intMapStart: Record<FilterIntervalType, string> = {
  enclosed: '[',
  not_enclosed: '(',
};
const intMapEnd: Record<FilterIntervalType, string> = {
  enclosed: ']',
  not_enclosed: ')',
};

interface FilterParam {
  name: Facets;
  values?: (FilterText | FilterInterval)[];
  multiplyValues?: Pick<FilterText, 'operator' | 'not'> & {
    values?: string[];
  };
}

export enum SortOptions {
  price = 'priceValue',
  ratingScore = 'ratingScore',
  title = 'headline',
  relevancy = 'Relevancy',
}

export enum SortOrder {
  asc = 'asc',
  desc = 'desc',
}

export type Arranging = 'asc' | 'desc';

export interface ISortBy {
  field: SortOptions;
  direction: Arranging;
}

export interface ISortOption {
  name: SortOptions;
  order: Arranging;
  description: string;
}

interface FFQueryParameters {
  filter?: FilterParam[];
  additionalParams?: AdditionalParameters;
}

export const adaptFFQueryParameters = (
  config: FFQueryParameters,
  isSearch: boolean = false,
) => {
  const { filter, additionalParams } = config;
  let params: Parameters = [];

  if (filter?.length) {
    const paramName = isSearch ? 'filter' : 'substringFilter';

    params = filter
      .flatMap((item) => {
        let query = `${item.name}:`;
        if (!!item?.multiplyValues?.values?.length) {
          const mData = item.multiplyValues;
          const op = mData.operator ? operators[mData.operator] : '';

          query += mData.values?.join(`${op}${mData.not ? '!' : ''}`);

          return [[paramName, query]];
        }

        return item?.values?.map((val) => {
          if (val.type === 'interval') {
            const start = val.start ? intMapStart[val.start] : '';
            const end = val.end ? intMapEnd[val.end] : '';

            query += `${start}${val.value_1},${val.value_2 || ''}${end}`;

            return [paramName, query];
          }

          if (val.type === 'string') {
            if (!val.value_2) {
              query += val.value_1;

              return [paramName, query];
            } else {
              const op = val.operator ? operators[val.operator] : '';

              query += `${val.value_1}${op}${val.not ? '!' : ''}${val.value_2}`;

              return [paramName, query];
            }
          }
        });
      })
      .filter((a) => !!a) as Parameters; // [['substringFilter', 'Title:sexy'], ['Title:Red~~~!Green'], ['substringFilter', 'PriceValue:[23,84)']]
  }

  const additionalParamsArray = [];

  for (const key in additionalParams) {
    additionalParamsArray.push([key, additionalParams[key]]);
  }

  return new URLSearchParams([
    ...params,
    ...additionalParamsArray,
  ] as string[][]);
};
